import Price from "@components/Price/Price";
import { useApp } from "@hooks/useApp";
import { useLocalisation } from "@hooks/useLocalisation";
import { ProductVariant } from "@shopify/hydrogen-react/storefront-api-types";
import React from "react";
import AddToCart from "../AddToCart/AddToCart";

type UpsellProps = {
  handle: string;
  imageSrc: string;
  title: string;
  variant: ProductVariant;
};

const Upsell = ({ handle, imageSrc, title, variant }: UpsellProps) => {
  const {
    config: {
      settings: { routes },
    },
  } = useApp();
  const { navigate } = useLocalisation();

  const productLink = `${routes.PRODUCT}/${handle}`;

  return (
    <div className="flex flex-col justify-between px-micro first:pl-zero last:pr-zero">
      <img src={imageSrc} alt={title} className="bg-canvas" />
      <p
        className="mt-[10px] cursor-pointer text-hint font-medium leading-hint hover:text-secondary"
        onClick={() => navigate(productLink)}
      >
        {title}
      </p>
      <Price price={variant?.price} layout="cart" />
      <AddToCart
        className="mt-[20px]"
        selectedVariant={variant}
        upsell={true}
      />
    </div>
  );
};

export default Upsell;
